import React, { useEffect, useMemo, useRef, useState } from 'react';
import style from './index.module.less';
import { CommonBackContent } from '../Layouts/CommonBackContent';
import RewriteTools from '@/components/Common/ToolsCommon/RewriteTool';
import RelevantProduction from '@/components/Common/ToolsCommon/RelevantProduction';
import { PlusCircleOutlined, DeleteOutlined } from '@ant-design/icons';
import { Button, Input, message } from 'antd';
import { useRouter } from 'next/router';
import { postRestrictedWordCheckApi, postToolsReviewApi, getRestrictedCount } from '@/lib/service';
import { useUserProvider } from '@/context/UserProvider';
import TranksModal from '@/components/CaptionTool/thanksModal';
import { useConfigProvider } from '@/context/ConfigProvider';
import { useTranslation } from 'next-i18next';
import dynamic from 'next/dynamic';
const FreQuestion = dynamic(() => import('./freQuestions/index'), {
  ssr: true,
});

const TwoBlogSec = dynamic(() => import('@/components/Common/TwoBlogSec'), {
  ssr: true,
});
const Index: React.FC<any> = ({ data }) => {
  const { t } = useTranslation('common');
  const { isMobile } = useConfigProvider();
  const { isLogin, onOpenLoginModal } = useUserProvider();
  const router = useRouter();
  const [content, setContent] = useState('');
  const [rightStatus, setRightStatus] = useState(1); // 1 默认 2 有问题 3 无问题
  const [loading, setLoading] = useState(false);
  const [dataInfo, setDataInfo] = useState<any>({});

  const ShowInfo = useRef({
    title1: t('Why Choose Erasa’s'),
    title2: t('Restricted Words Checker？'),
    color: '#E9F2FF',
    mainList: [
      {
        title: t('Spot Sensitive Words, Stay Compliant:'),
        main: t(
          'Erasa quickly identifies restricted words, keeping your BIO、DM from bans and ensuring compliance every time.',
        ),
        img: '/images/tool/r-1-1.webp',
      },
      {
        title: t('Boost Efficiency, Save Time:'),
        main: t(
          'Forget manual reviews—Erasa automates the process, cutting down on missed violations so you can focus on what you do best: creating.',
        ),
        img: '/images/tool/r-1-2.webp',
      },
      {
        title: t('Get Insights, Improve Your Content:'),
        main: t(
          'With detailed reports and suggestions, Erasa helps you fine-tune your content, reducing violations and enhancing overall quality.',
        ),
        img: '/images/tool/r-1-3.webp',
      },
      {
        title: t('Stay Updated, Stay Protected:'),
        main: t(
          "Erasa's word bank is constantly updated to match the latest rules, keeping you ahead of policy changes and out of trouble.",
        ),
        img: '/images/tool/r-1-4.webp',
      },
    ],
  });
  const showProInfo = useRef({
    title: t('Other Relevant Products'),
    mainList: [
      {
        a: `${process.env.NEXT_APP_WEB_HOST}/${data.locale}/onlyfans-caption-generator`,
        img: '/images/tool/1.webp',
        title: t('Free OnlyFans Caption Generator'),
        desc: t('Rewrite to meet OnlyFans guidelines without losing your unique style.'),
      },
      {
        a: `${process.env.NEXT_APP_WEB_HOST}`,
        img: '/images/tool/2.webp',
        title: t('Unlimited Content Leak Removal'),
        desc: t(
          'Detect and remove leaked OnlyFans content，protecting your brand and earnings from unauthorized sharing.',
        ),
      },
    ],
  });
  const [power, setPower] = useState(0);
  const handleCheck = () => {
    if (content.length == 0) {
      message.warning('content cannot be blank');
      return;
    }
    if (!isLogin) {
      onOpenLoginModal(true);
      return;
    }
    if (restric.num == '1') {
      setIsModalOpen(true);
    }
    setLoading(true);
    postRestrictedWordCheckApi({ content }).then((res) => {
      setLoading(false);
      if (res.code == 0) {
        setDataInfo(res.data);
        let tempStr = {
          total_num: res.data.total_num,
          num: res.data.num,
        };
        setRestric(tempStr);
        if (res.data.restricted_words_num == 0) {
          setRightStatus(3);
        } else {
          setRightStatus(2);
        }
      } else {
        message.warning(res.message);
        setRightStatus(1);
      }
    });
  };
  // 渲染模板
  const renderHtml: string = useMemo(() => {
    let renderStr: string = '';
    dataInfo?.content?.forEach((item: any) => {
      if (item.word == '\n') {
        item.word = `</br>`;
      }
    });

    dataInfo?.content?.forEach((item: any) => {
      renderStr += `<span style='color:${item.mark ? 'red' : ''};background:${item.mark ? '#FEEDED' : ''}'>${
        item.word
      }</span>`;
    });
    return renderStr;
  }, [dataInfo]);
  const handleCopy = () => {
    setContent(
      `Hi there, welcome to my page! 💖 
I delighted you're here 😇 I'm eager to connect more with you... 
I'm a tad reserved but I'm getting more comfortable, so please share your name and where you're from. 
♡ Exclusive videos! 
♡ Personalized content requests 
♡ Intimate voice messages 
♡ Access to private livestreams 
♡ And so much more... 💭 
Discover the exclusive content waiting for you here 🔑🔓... 
I'm thrilled to start this exciting journey together!! 💋💋💋"");`,
    );
  };
  // 点赞
  const isFirst = useRef(1);
  const handlePower = (status: number) => {
    if (status == power) {
      setPower(0);
      return;
    }
    if (status == 1 && dataInfo?.thumb_up_num == 0 && isFirst.current == 1) {
      isFirst.current = 2;
      setIsModalOpen(true);
    }
    // 1点赞 2down
    postToolsReviewApi(dataInfo.id, { status }).then((res) => {
      setPower(status);
    });
  };
  // 点击跳转到
  const handleToRetick = () => {
    localStorage.setItem('toolRetic', content);
    router.push('/onlyfans-caption-generator');
  };
  const [restric, setRestric] = useState({
    num: '',
    total_num: '',
  });
  const getRestTimes = () => {
    getRestrictedCount().then((res) => {
      setRestric(res.data);
    });
  };
  useEffect(() => {
    //获取次数
    if (isLogin) {
      getRestTimes();
    }
  }, [isLogin]);
  // 打开弹窗
  const [isModalOpen, setIsModalOpen] = useState(false);
  return (
    <CommonBackContent>
      <div className={style.container}>
        <h1>{t('Free OnlyFans Restricted Words Checker')}</h1>
        <div className={style.checkedTimes}>
          {t("Today's Usage")}{' '}
          <span>
            {restric?.num === '' ? '-' : restric?.num}/{restric?.total_num === '' ? '-' : restric?.total_num}
          </span>
        </div>
        <div className={style.main}>
          <div className={style.left}>
            <div className={style.main}>
              {/* 输入框 */}
              {rightStatus == 1 && (
                <div className={style.ipt}>
                  <Input.TextArea
                    placeholder={t('Enter or paste your OnlyFans content here to check for restricted words.')}
                    value={content}
                    onChange={(e) => {
                      if (e.target.value.length > 10000) {
                        message.warning(t('Character limit of 10,000 exceeded'));
                        return;
                      }
                      setContent(e.target.value);
                    }}
                  ></Input.TextArea>
                </div>
              )}
              {/* 渲染板 */}
              {(rightStatus == 2 || rightStatus == 3) && (
                <div
                  className={style.renderBlank}
                  onClick={() => {
                    setPower(0);
                    setRightStatus(1);
                  }}
                >
                  <div dangerouslySetInnerHTML={{ __html: renderHtml }}></div>
                </div>
              )}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignContent: 'center',
                  marginBottom: '5px',
                }}
              >
                <div className={style.opt1}>
                  {content.length > 0 && (
                    <div className={style.gar}>
                      <span>Total Words: {content.length}</span>
                      <DeleteOutlined
                        className={style.icon}
                        onClick={() => {
                          setContent('');
                          setRightStatus(1);
                          setPower(0);
                        }}
                      />
                    </div>
                  )}
                  {content.length == 0 && (
                    <div className={style.sample} onClick={handleCopy}>
                      <PlusCircleOutlined className={style.icon} />
                      <span>{t('Sample Text')}</span>
                    </div>
                  )}
                </div>
                {(rightStatus == 3 || rightStatus == 2) && isMobile && (
                  <div>
                    <img
                      onClick={() => handlePower(1)}
                      style={{ marginRight: '5px', cursor: 'pointer' }}
                      src={power == 1 ? '/images/tool/up1-1.svg' : '/images/tool/up1.svg'}
                      alt="up"
                    />
                    <img
                      style={{ marginRight: '5px', cursor: 'pointer' }}
                      onClick={() => handlePower(2)}
                      src={power == 2 ? '/images/tool/down1-1.svg' : '/images/tool/down1.svg'}
                      alt="down"
                    />
                  </div>
                )}
              </div>
            </div>
            <div className={style.opt}>
              {content.length > 0 && !isMobile && (
                <div className={style.gar}>
                  <span>Total Words: {content.length}</span>
                  <DeleteOutlined
                    className={style.icon}
                    onClick={() => {
                      setContent('');
                      setRightStatus(1);
                      setPower(0);
                    }}
                  />
                </div>
              )}
              {content.length == 0 && (
                <div className={style.sample} onClick={handleCopy}>
                  <PlusCircleOutlined className={style.icon} />
                  <span>{t('Sample Text')}</span>
                </div>
              )}
              <div className={style.optBtn}>
                {rightStatus == 1 && (
                  <div>
                    <Button onClick={handleCheck} loading={loading}>
                      {t('Check')}
                    </Button>
                    <Button onClick={handleToRetick}>{t('Try AI Rewrite')}</Button>
                  </div>
                )}
                {(rightStatus == 2 || rightStatus == 3) && !isMobile && (
                  <div className={style.opt}>
                    <img
                      onClick={() => handlePower(1)}
                      src={power == 1 ? '/images/tool/up1-1.svg' : '/images/tool/up1.svg'}
                      alt="up"
                    />
                    <img
                      onClick={() => handlePower(2)}
                      src={power == 2 ? '/images/tool/down1-1.svg' : '/images/tool/down1.svg'}
                      alt="down"
                    />
                    <img src="/images/tools/allRight.webp" alt="right" />
                    <span>Analysis complete</span>
                  </div>
                )}
                {rightStatus == 2 && isMobile && (
                  <div className={style.leftRightErr}>
                    <div>
                      <img src="/images/tools/allRight.webp" alt="erasa" />
                      <span>{t('Analysis complete')}</span>
                    </div>
                    <div>
                      <span>{dataInfo?.restricted_words_num || '-'}</span>
                      <span>{t('restricted words contains')}</span>
                    </div>
                  </div>
                )}
                {rightStatus == 3 && isMobile && (
                  <div className={style.leftRightSucc}>
                    <div>
                      <img src="/images/tools/allRight.webp" alt="erasa" />
                    </div>
                    <div>
                      <div>{t('Good to go!')}</div>
                      <div>{t('No restricted words found.')}</div>
                    </div>
                  </div>
                )}
                {(rightStatus == 2 || rightStatus == 3) && isMobile && (
                  <div className={style.bottomc}>
                    <div>{t('Avoid Restricted Words')}</div>
                    <div>
                      <Button onClick={handleToRetick}>{t('Try AI Rewrite')}</Button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className={style.right}>
            {rightStatus == 1 && <div className={style.init}>{t('Rewrite Display Area')}</div>}
            {rightStatus == 2 && (
              <div className={style.checkErr}>
                <div>{dataInfo.restricted_words_num}</div>
                <div>{t('restricted words contains')}</div>
                <div className={style.bottom}>
                  <div>{t('Avoid Restricted Words')}</div>
                  <Button onClick={handleToRetick}>Try AI Rewrite</Button>
                </div>
              </div>
            )}
            {rightStatus == 3 && (
              <div className={style.checkSucc}>
                <div>
                  <img src="/images/tools/allRight.webp" alt="erasa" />
                </div>
                <div>{t('Good to go!')}</div>
                <div>{t('No restricted words found.')}</div>
                <div className={style.bottom}>
                  <div>{t('Avoid Restricted Words')}</div>
                  <Button onClick={handleToRetick}>{t('Try AI Rewrite')}</Button>
                </div>
              </div>
            )}
          </div>
        </div>
        <RewriteTools showInfo={ShowInfo.current}></RewriteTools>
        <RelevantProduction showProInfo={showProInfo.current}></RelevantProduction>
        <TwoBlogSec
          blogList={data.data.blogList}
          topBlogList={data.data.topBlogList}
          blogTitle={data.data.contentInfo['section-blog']?.title ?? ''}
          topBlogTitle={data.data.contentInfo['section-top-blog']?.title ?? ''}
        />
        <FreQuestion data={data.data} />
      </div>
      <TranksModal isModalOpen={isModalOpen} handleClose={() => setIsModalOpen(false)}></TranksModal>
    </CommonBackContent>
  );
};

export default Index;
